import LegalLayout from "./LegalLayout";

export default function AGB() {
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen">
      <section className="space-y-8 font-serif text-lg text-charcoal leading-relaxed">
        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 1 Geltungsbereich und Anbieter</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle Verträge zwischen
            dem Nutzer (nachfolgend „Sie" oder „Kunde") und
          </p>
          <p className="mt-3">
            Stephanie Dreier<br />
            Saritscher Hauptstraße 12<br />
            02699 Neschwitz<br />
            E-Mail:{" "}
            <a href="mailto:hallo@oratiorede.de" className="underline underline-offset-4 hover:text-umber">
              hallo@oratiorede.de
            </a>
          </p>
          <p className="mt-3">
            (nachfolgend „Anbieterin"), die über die Website{" "}
            <a href="https://oratiorede.de" className="underline underline-offset-4 hover:text-umber">
              oratiorede.de
            </a>{" "}
            geschlossen werden. Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn,
            die Anbieterin stimmt ihrer Geltung ausdrücklich schriftlich zu.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 2 Leistungsgegenstand</h2>
          <p>
            Die Anbieterin stellt einen KI-gestützten, individuell aus den Angaben des Kunden formulierten
            Trauerrede-Entwurf zur Verfügung. Der Entwurf wird auf Basis der über das Online-Formular
            eingegebenen Antworten automatisiert generiert und ist als Ausgangspunkt zur persönlichen
            Weiterbearbeitung gedacht.
          </p>
          <p className="mt-3">
            Der Entwurf wird dem Kunden nach erfolgreicher Zahlung sofort im Browser angezeigt, als
            PDF-Download bereitgestellt und zusätzlich an die vom Kunden angegebene E-Mail-Adresse
            gesendet.
          </p>
          <p className="mt-3">
            Eine Gewährleistung für inhaltliche Richtigkeit oder Eignung für einen bestimmten Zweck wird
            nicht übernommen. Der Kunde ist selbst dafür verantwortlich, den Entwurf vor Verwendung zu
            prüfen und gegebenenfalls anzupassen.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 3 Vertragsschluss</h2>
          <p>
            Die Darstellung der Leistungen auf der Website stellt kein rechtlich bindendes Angebot dar,
            sondern eine unverbindliche Aufforderung zur Bestellung. Mit Anklicken des
            Zahlungs-Buttons und erfolgreichem Abschluss der Zahlung über Stripe geben Sie ein
            verbindliches Angebot ab. Der Vertrag kommt mit Bestätigung der Zahlung durch Stripe und
            Freischaltung des Generators zustande.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 4 Preise und Zahlung</h2>
          <p>
            Es gelten die zum Zeitpunkt der Bestellung auf der Website ausgewiesenen Preise. Alle Preise
            verstehen sich als Endpreise inklusive der gesetzlichen Mehrwertsteuer.
          </p>
          <p className="mt-3">
            Aktuell werden folgende Pakete angeboten:
          </p>
          <ul className="mt-3 space-y-1 list-disc list-inside">
            <li>Standard-Entwurf: 29,00 € (bis 1.000 Wörter)</li>
            <li>Umfangreicher Entwurf: 49,00 € (bis 2.000 Wörter)</li>
          </ul>
          <p className="mt-3">
            Die Zahlung erfolgt ausschließlich über den Zahlungsdienstleister Stripe (Stripe Payments
            Europe, Ltd.). Es gelten die AGB und Datenschutzbestimmungen von Stripe. Die Anbieterin
            erhält keinen Zugriff auf vollständige Zahlungsdaten.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 5 Widerrufsrecht bei digitalen Inhalten</h2>
          <p>
            Bei Verträgen über die Lieferung von nicht auf einem körperlichen Datenträger befindlichen
            digitalen Inhalten (hier: der individuell erstellte Trauerrede-Entwurf) erlischt das
            Widerrufsrecht gemäß § 356 Abs. 5 BGB, sobald die Anbieterin mit der Ausführung des Vertrags
            begonnen hat, nachdem der Kunde
          </p>
          <ol className="mt-3 space-y-1 list-decimal list-inside">
            <li>
              ausdrücklich zugestimmt hat, dass die Anbieterin mit der Ausführung des Vertrags vor
              Ablauf der Widerrufsfrist beginnt, und
            </li>
            <li>
              seine Kenntnis davon bestätigt hat, dass er durch seine Zustimmung mit Beginn der
              Ausführung des Vertrags sein Widerrufsrecht verliert.
            </li>
          </ol>
          <p className="mt-3">
            Mit Auslösen der Zahlung erklärt der Kunde ausdrücklich, dass er einer sofortigen Ausführung
            des Vertrags zustimmt und zur Kenntnis nimmt, dass sein Widerrufsrecht mit Beginn der
            Ausführung erlischt.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 6 Nutzungs- und Urheberrechte</h2>
          <p>
            Der vom Kunden bestellte Entwurf wird ihm zur freien persönlichen und beruflichen Nutzung
            überlassen (Redevortrag, Weitergabe an Angehörige, Bearbeitung, Vervielfältigung für den
            privaten oder beruflichen Gebrauch). Die Anbieterin behält sich keine Rechte am
            erzeugten Text vor.
          </p>
          <p className="mt-3">
            Der Kunde sichert zu, dass die von ihm eingegebenen Angaben zu Personen keine Rechte Dritter
            verletzen. Für den Inhalt der Eingaben ist ausschließlich der Kunde verantwortlich.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 7 Haftung</h2>
          <p>
            Die Anbieterin haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie nach den
            Bestimmungen des Produkthaftungsgesetzes. Bei leichter Fahrlässigkeit haftet die Anbieterin
            nur bei Verletzung einer wesentlichen Vertragspflicht (Kardinalpflicht) und begrenzt auf den
            vertragstypisch vorhersehbaren Schaden.
          </p>
          <p className="mt-3">
            Die Anbieterin haftet nicht für die inhaltliche Eignung des automatisch erzeugten Entwurfs
            für einen bestimmten Anlass oder Sprechauftritt. Der Kunde ist verpflichtet, den Entwurf
            vor Verwendung eigenständig zu prüfen und gegebenenfalls anzupassen.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 8 Datenschutz</h2>
          <p>
            Der Umgang mit personenbezogenen Daten ist in der{" "}
            <a href="/datenschutz" className="underline underline-offset-4 hover:text-umber">
              Datenschutzerklärung
            </a>{" "}
            beschrieben. Insbesondere werden Angaben zu verstorbenen Personen nicht dauerhaft
            gespeichert.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 9 Streitbeilegung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-4 hover:text-umber"
            >
              https://ec.europa.eu/consumers/odr
            </a>.
            Die Anbieterin ist weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-2">§ 10 Schlussbestimmungen</h2>
          <p>
            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Sollte
            eine Bestimmung dieser AGB unwirksam sein oder werden, so bleibt die Wirksamkeit der übrigen
            Bestimmungen unberührt.
          </p>
        </div>

        <p className="text-sm text-ink/60 pt-8 border-t border-umber/10">
          Stand: Februar 2026
        </p>
      </section>
    </LegalLayout>
  );
}
